import { Layout } from 'antd';
import styled from 'styled-components';

// Header is now mobile-only (desktop uses Sidebar)
export const HeaderStyled = styled(Layout.Header)`
  color: var(--white);
  font-family: 'Roboto';
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 1;
  padding: 0 12px 0 16px;
  background-color: #374151;
  height: 56px;

  a {
    display: flex;
    align-items: center;
    height: 100%;

    /* Logo wrapper */
    .ant-image {
      display: flex;
      align-items: center;
      line-height: 0;
      height: 28px;
    }

    img {
      display: block;
      object-fit: contain;
      max-width: 140px;
      height: 28px !important;
    }
  }

  /* Menu button with proper touch target */
  > svg {
    width: 28px;
    height: 28px;
    color: var(--white);
    cursor: pointer;
    padding: 8px;
    box-sizing: content-box;
    margin: -8px;
    border-radius: 8px;
    transition: background-color 0.2s;

    &:active {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
`;

export const BackContainer = styled.div`
  display: flex;
  align-items: center;
  color: var(--white);
  font-size: 17px;
  font-weight: 500;
  height: 100%;

  svg {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    cursor: pointer;
    padding: 10px;
    box-sizing: content-box;
    margin-left: -10px;
    border-radius: 8px;

    &:active {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
`;
